import Axios from "../../api/Axios";
const BASE_URL = "ColateralDestroy/";

export const EndpointCollateralDestroy = {
    PopulateSTKAdjstData: "PopulateSTKAdjstData",
    GetColateralDestroyData: "GetColateralDestroyData",
    GetStkHeaderData: "GetStkHeaderData",
    GetSTKDetailsData: "GetSTKDetailsData",
    SubmitRecord: "SubmitRecord"
};

export const createAPIEndpointCollateralDestroy = () => {
    return { 
        get: (Endpoint) => Axios.get(BASE_URL + Endpoint),
        post: (Endpoint, data) => Axios.post(BASE_URL + Endpoint, data),
    };

};
